import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { CompensationProps } from '../../../models/arc-epi-props';

export interface OneTimePaymentFormValues {
    effective_date: string;
    amount: number | string;
}

export const OneTimePaymentValidationSchema = (compensationProps: CompensationProps, labelSettings: LabelSettingProps) => {
    return Yup.object().shape({
        effective_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, compensationProps.paymentEffectiveDateLabel)),
        amount: Yup.number().positive(labelSettings.numberPositive),
    });
};